import { Popover } from "antd"
import OutsideAlerter from "components/view-utils/outside-alerter"
import { useState } from "react"
import { SidebarButton } from "../sidebar-button"
import { useFormikContext } from "formik"
import { TApiTaskDetails } from "@timenotes/shared/src/services/api-client/types"
import { ProjectSectionSelect } from "components/timenotes/projects/project-section-select"
import { useGetProjectSection } from "@timenotes/shared/src/services/project-sections/queries/use-get-project-section"

interface TaskProjectSectionSelectPopoverProps extends React.PropsWithChildren { }

export const TaskProjectSectionSelectPopover = (props: TaskProjectSectionSelectPopoverProps) => {

  const formik = useFormikContext<TApiTaskDetails>()
  const task = formik.values

  const [visible, setVisible] = useState(false)

  const projectSection = useGetProjectSection({
    projectSectionId: task.projectSectionId
  })

  return (
    <>
      <OutsideAlerter
        onClick={() => setVisible(false)}
      >
        <Popover
          getPopupContainer={(triggerNode: any) => triggerNode}
          content={(
            <ProjectSectionSelect
              showSearch
              autoFocus
              getPopupContainer={(triggerNode) => triggerNode}
              open={true}
              projectId={task.project.id}
              value={formik.values.projectSectionId}
              onChange={(projectSectionId) => {
                formik.setFieldValue('projectSectionId', projectSectionId)
                formik.submitForm()
                setVisible(false)
              }}

              onKeyDown={(e: any) => {
                if (e.key == 'Escape') {
                  setVisible(false)
                }
              }}
            />
         )}
          destroyTooltipOnHide={true}
          placement="bottom"
          trigger={[]}
          visible={visible}
        >
          <div onClick={() => setVisible((v) => (!v))}>
            {props.children || <DefaultTarget />}
          </div>
        </Popover>
      </OutsideAlerter>

      <div
        style={{
          cursor: 'pointer',
          overflow: 'hidden',
          whiteSpace: 'nowrap', // Ensure the text stays on a single line
          textOverflow: 'ellipsis', // Add "..." for overflow text
          marginLeft: '8px',
        }}
        onClick={() => setVisible(true)}
      >
        {projectSection?.name}
      </div>

    </>
  )
}

const DefaultTarget = () => {
  return (
    <SidebarButton>
      Section
    </SidebarButton>
  )
}
